import type { IAddressService } from '@/services/interfaces/IAddressService'
import type { Address } from '@/types/address'

const mockAddresses: Address[] = [
  {
    id: '1',
    formattedAddress: 'Rua Augusta, 1000 - Consolação, São Paulo - SP, 01304-000',
    street: 'Rua Augusta',
    number: '1000',
    neighborhood: 'Consolação',
    city: 'São Paulo',
    state: 'SP',
    zipCode: '01304-000',
    country: 'Brasil',
    coordinates: { lat: -23.5505, lng: -46.6333 }
  },
  {
    id: '2',
    formattedAddress: 'Avenida Paulista, 1578 - Bela Vista, São Paulo - SP, 01310-200',
    street: 'Avenida Paulista',
    number: '1578',
    neighborhood: 'Bela Vista',
    city: 'São Paulo',
    state: 'SP',
    zipCode: '01310-200',
    country: 'Brasil',
    coordinates: { lat: -23.5613, lng: -46.6565 }
  },
  {
    id: '3',
    formattedAddress: 'Rua Oscar Freire, 500 - Jardins, São Paulo - SP, 01426-001',
    street: 'Rua Oscar Freire',
    number: '500',
    neighborhood: 'Jardins',
    city: 'São Paulo',
    state: 'SP',
    zipCode: '01426-001',
    country: 'Brasil',
    coordinates: { lat: -23.5618, lng: -46.6658 }
  },
  {
    id: '4',
    formattedAddress: 'Avenida Copacabana, 1000 - Copacabana, Rio de Janeiro - RJ, 22060-000',
    street: 'Avenida Copacabana',
    number: '1000',
    neighborhood: 'Copacabana',
    city: 'Rio de Janeiro',
    state: 'RJ',
    zipCode: '22060-000',
    country: 'Brasil',
    coordinates: { lat: -22.9685, lng: -43.1828 }
  },
  {
    id: '5',
    formattedAddress: 'Rua da Praia, 300 - Centro Histórico, Porto Alegre - RS, 90010-000',
    street: 'Rua da Praia',
    number: '300',
    neighborhood: 'Centro Histórico',
    city: 'Porto Alegre',
    state: 'RS',
    zipCode: '90010-000',
    country: 'Brasil',
    coordinates: { lat: -30.0346, lng: -51.2177 }
  },
  {
    id: '6',
    formattedAddress: 'Avenida Boa Viagem, 2000 - Boa Viagem, Recife - PE, 51111-000',
    street: 'Avenida Boa Viagem',
    number: '2000',
    neighborhood: 'Boa Viagem',
    city: 'Recife',
    state: 'PE',
    zipCode: '51111-000',
    country: 'Brasil',
    coordinates: { lat: -8.1148, lng: -34.8990 }
  },
  {
    id: '7',
    formattedAddress: 'Rua das Flores, 150 - Centro, Curitiba - PR, 80020-000',
    street: 'Rua das Flores',
    number: '150',
    neighborhood: 'Centro',
    city: 'Curitiba',
    state: 'PR',
    zipCode: '80020-000',
    country: 'Brasil',
    coordinates: { lat: -25.4284, lng: -49.2733 }
  }
]

export class MockAddressService implements IAddressService {
  async searchAddresses(query: string): Promise<Address[]> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 300))

    if (!query || query.length < 2) {
      return []
    }

    const normalizedQuery = query.toLowerCase().trim()
    
    return mockAddresses.filter(address => 
      address.formattedAddress.toLowerCase().includes(normalizedQuery) ||
      address.street?.toLowerCase().includes(normalizedQuery) ||
      address.neighborhood?.toLowerCase().includes(normalizedQuery) ||
      address.city.toLowerCase().includes(normalizedQuery) ||
      address.state.toLowerCase().includes(normalizedQuery)
    )
  }

  async getCurrentLocation(): Promise<Address> {
    // Simulate getting current location
    await new Promise(resolve => setTimeout(resolve, 1000))

    // Return a mock current location (São Paulo center)
    return {
      id: 'current-location',
      formattedAddress: 'Rua XV de Novembro, 200 - Centro, São Paulo - SP, 01013-000',
      street: 'Rua XV de Novembro',
      number: '200',
      neighborhood: 'Centro',
      city: 'São Paulo',
      state: 'SP',
      zipCode: '01013-000',
      country: 'Brasil',
      coordinates: { lat: -23.5489, lng: -46.6388 }
    }
  }

  async getAddressDetails(addressId: string): Promise<Address> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 200))

    const address = mockAddresses.find(addr => addr.id === addressId)
    
    if (!address) {
      throw new Error('Endereço não encontrado')
    }

    return address
  }
}